export const AppUrl = 'https://www.dota1x6.com/';
export const CdnUrl = 'https://cdn.dota1x6.com/';
export const StatsUrl = 'https://stats.dota1x6.com/';
export const SharedHeroTalent = 'skill0';
export const UpdateHeroTalent = 'hero_talent';